export enum PipelineTransactionCategoryEnum {
  tenantRepresentation = 'Tenant Representation',
  buyerRepresentation = 'Buyer Representation',
  landlordRepresentation = 'Landlord Representation',
  sellerRepresentation = 'Seller Representation',
  sublessor = 'Sublessor',
  sublease = 'Sublease',
  dualAgency = 'Dual Agency',
}
